import React, { useEffect, useState } from 'react';
import { number } from 'prop-types';
import moment from 'moment';

import { TimeSlot } from './Timer';

import './Timer.scss';
import './DaysLeft.scss';
import 'src/dashboard/shared/Modal.scss';

// match 'in 123 days/months/...' text
// const futureRegex = /in \d* .*/;

const getText = (endTime) => {
  const targetDate = moment.unix(endTime);

  // returns 'in 2 days' or '3 month ago'
  const timeLeftText = targetDate.fromNow();

  if (timeLeftText == "in a day") {
    return "1 DAY LEFT";
  }
  
  if (targetDate.isAfter(moment())) {
    return `${timeLeftText.slice(3)} LEFT`.toLocaleUpperCase();
  }

  return 'TRIAL EXPIRED';
};

const getLabel = (endTime) => {
  const targetDate = moment.unix(endTime);
  // returns 'in 2 days' or '3 month ago'
  const timeLeftText = targetDate.fromNow();
  if (timeLeftText == "a day ago") {
    return "1 day ago";
  }
  if (targetDate.isBefore(moment())) {
    return timeLeftText;
  }
  return 'IN TRIAL PERIOD';
}

const DaysLeft = ({ endTime, onClick }) => {
  const [text, setText] = useState(getText(endTime));
  const [label, setLabel] = useState(getLabel(endTime));

  useEffect(() => {
    setText(getText(endTime));
    setLabel(getLabel(endTime));
  }, [endTime]);

  return (
    <div className="days-left">
      <div onClick={onClick} className="timer">
        <TimeSlot label={[label]} slots={[text]} />
      </div>
    </div>
  );
};

DaysLeft.propTypes = {
  endTime: number,
};

DaysLeft.defaultProps = {
  endTime: 0,
};

export default DaysLeft;
